import { TYPES } from "../actions/types";

const initialState = {
  products: [],
  totalCount: 0,
  currentProduct: null,
  loading: false,
  error: null
};

export const tkt1ProductReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.ACTION_GET_TKT1_PRODUCTS_SUCCESS:
      console.log('[Debug] TKT1 Product Reducer - Success payload:', action.payload);
      return {
        ...state,
        products: action.payload.data || [],
        totalCount: action.payload.pagination?.total_count || 0,
        loading: false,
        error: null
      };
    
    case TYPES.ACTION_GET_TKT1_PRODUCTS_FAIL:
      return {
        ...state,
        products: [],
        totalCount: 0,
        loading: false,
        error: action.payload.message || 'Failed to fetch products'
      };
    
    case TYPES.ACTION_GET_TKT1_PRODUCT_BY_ID_SUCCESS:
    case TYPES.ACTION_GET_TKT1_PRODUCT_BY_MID_SUCCESS:
      return {
        ...state,
        currentProduct: action.payload.data,
        loading: false,
        error: null
      };
    
    case TYPES.ACTION_GET_TKT1_PRODUCT_BY_ID_FAIL:
    case TYPES.ACTION_GET_TKT1_PRODUCT_BY_MID_FAIL:
      return {
        ...state,
        currentProduct: null,
        loading: false,
        error: action.payload.message || 'Failed to fetch product'
      };
    
    case TYPES.ACTION_CREATE_TKT1_PRODUCT_SUCCESS:
      return {
        ...state,
        products: [action.payload.data, ...state.products],
        totalCount: state.totalCount + 1,
        loading: false,
        error: null
      };
    
    case TYPES.ACTION_CREATE_TKT1_PRODUCT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.message || 'Failed to create product'
      };
    
    case TYPES.ACTION_UPDATE_TKT1_PRODUCT_SUCCESS:
    case TYPES.ACTION_UPDATE_TKT1_PRODUCT_BY_MID_SUCCESS:
      return {
        ...state,
        products: state.products.map(product => 
          product._id === action.payload.data._id ? action.payload.data : product
        ),
        currentProduct: state.currentProduct && state.currentProduct._id === action.payload.data._id 
          ? action.payload.data 
          : state.currentProduct,
        loading: false,
        error: null
      };
    
    case TYPES.ACTION_UPDATE_TKT1_PRODUCT_FAIL:
    case TYPES.ACTION_UPDATE_TKT1_PRODUCT_BY_MID_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.message || 'Failed to update product'
      };
    
    case TYPES.ACTION_DELETE_TKT1_PRODUCT_SUCCESS:
      return {
        ...state,
        products: state.products.filter(product => product._id !== action.payload.id),
        totalCount: Math.max(0, state.totalCount - 1),
        loading: false,
        error: null
      };
    
    case TYPES.ACTION_DELETE_TKT1_PRODUCT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.message || 'Failed to delete product'
      };
    
    case TYPES.ACTION_SEARCH_TKT1_PRODUCTS_SUCCESS:
      return {
        ...state,
        products: action.payload.data || [],
        totalCount: action.payload.pagination?.total_count || 0,
        loading: false,
        error: null
      };
    
    case TYPES.ACTION_SEARCH_TKT1_PRODUCTS_FAIL:
      return {
        ...state,
        products: [],
        totalCount: 0,
        loading: false,
        error: action.payload.message || 'Failed to search products'
      };
    
    case TYPES.ACTION_CALL_API_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.message || 'API call failed'
      };
    
    default:
      return state;
  }
};
